// extracted by mini-css-extract-plugin
export var assigneeBadge = "_js-0";
export var assigneeDetails = "_js-1";
export var assigneeInfo = "_js-2";
export var dropdownContainer = "_js-4";
export var dropdownImage = "_js-5";
export var editAssigneeInfo = "_js-3";
export var editAssigneeModalContainer = "_js-6";
export var hidden = "_js-8";
export var input = "_js-7";